import '../../external/jquery.ui.touch-punch.min';

export const VEHICLE_LOAN = {
    NO_LOAN: '0',
    HAS_LOAN: '1',
};

export const sellVehicleLoanSlider = {
    sliderName: '',
    valueElement: '',
    sliderMaximum: 1, // Only two values: 0 (No) and 1 (Yes)
    list: ['0', '1'],

    init(optionsInput) {
        const options = optionsInput || {};
        this.sliderName = options.sliderName ? options.sliderName : $('#sellVehicleLoanSlider');
        this.valueElement = options.valueElement ? options.valueElement : $('#vehicleLoanValue');

        // Initialize the slider
        this.sliderName.slider({
            animate: true,
            range: 'min',
            min: 0,
            max: this.sliderMaximum,
            step: 1,
            create() {
                const initialValue = sellVehicleLoanSlider.valueElement.val();
                sellVehicleLoanSlider.setSlider(initialValue);
                sellVehicleLoanSlider.updateDisplay();
            },
            slide(event, ui) {
                sellVehicleLoanSlider.valueElement.val(sellVehicleLoanSlider.list[ui.value]);
            },
            stop() {
                sellVehicleLoanSlider.valueElement.trigger('change');
            },
        });

        // Add click event listeners for labels
        this.addLabelClickEvents();

        // Add click event for slider track
        this.addTrackClickEvent();
    },
    setSlider(value) {
        const index = this.list.indexOf(value);
        this.sliderName.slider('value', index >= 0 ? index : 0);
        this.updateDisplay();
    },
    updateDisplay() {
        const currentValue = this.sliderName.slider('value');
        this.valueElement.val(this.list[currentValue]);

        // Update label highlighting (optional)
        $('#labelNo').toggleClass('active', currentValue === 0);
        $('#labelYes').toggleClass('active', currentValue === 1);
    },
    addLabelClickEvents() {
        // Add click events for labels
        $('#labelNo').click(() => {
            this.setSlider('0');
        });
        $('#labelYes').click(() => {
            this.setSlider('1');
        });
    },
    addTrackClickEvent() {
        // Add click event listener for the slider track
        this.sliderName.parent().on('click', (event) => {
            // Check if the click is not on the handle
            if (!$(event.target).hasClass('ui-slider-handle')) {
                const sliderOffset = this.sliderName.offset();
                const sliderWidth = this.sliderName.width();
                const clickPosition = event.pageX - sliderOffset.left;

                // Calculate the new slider value based on click position
                const newValue = Math.round((clickPosition / sliderWidth) * this.sliderMaximum);

                // Set the slider to the new value
                this.setSlider(this.list[newValue] || '0');
            }
        });
    },
};
